export default str => str === 'Collection'



// WEBPACK FOOTER //
// ./src/helpers/isOverview.js